<template>
  <div>
    <el-form ref="form" :model="formData">
      <el-row :gutter="20">
        <el-col :span="span" v-for="(item,index) in formData.attrs" :key="index">
          <el-form-item
            :label="item.label"
            :prop="'attrs.' + index + '.values'"
            :rules="[{required: item.required, message: `${item.label} required`}]"
          >
            <component
              v-if="item.type!=='select'"
              :is="`el-${item.type}`"
              v-model="item.values"
              :disabled="disabled"
              clearable
              :size="size"
              style="width:100%;"
            />
            <el-select
              v-else
              v-model="item.values"
              :multiple="item.multiple"
              clearable
              filterable
              :disabled="disabled"
              :placeholder="'请选择'+item.label"
              :rules="item.rules"
              :size="size"
              style="width:100%;"
            >
              <el-option
                v-for="option in item.data"
                :key="option.key"
                :label="option.label"
                :value="option.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'Attribute',
  props: {
    autoLoad: {
      default: false,
      type: Boolean
    },
    params: {
      default: null,
      type: Object
    },
    disabled: {
      default: false,
      type: Boolean
    },
    size: {
      default: 'small',
      type: String
    },
    span:{
      default: 12,
      type: Number
    }
  },
  created () {
    if (this.autoLoad) {
      this.load()
    }
  },
  data () {
    return {
      formData: {
        attrs: []
      }
    }
  },
  watch: {
    params (value) {
      if (value) {
        this.load()
      }
    }
  },
  methods: {
    load (value) {
      this.$api.getAttributeData(value || this.params).then(res => {
        this.formData.attrs = res.body.data
      })
    },
    validate () {
      let result = false
      this.$refs.form.validate((valid) => {
        result = valid
      })
      return result
    },
    getFormData () {
      let formData = {
        ...this.params
      }
      formData.attributeList = this.formData.attrs.map(item => {
        let attributeValueEn = item.values
        let attributeValueZh = item.values
        if (item.values instanceof Array) {
          let chooseAttr = item.data.filter(temp => {
            return item.values.indexOf(temp.value) !== -1
          })
          attributeValueEn = chooseAttr.map(temp => temp.value).join(',') || item.values[0]
          attributeValueZh = chooseAttr.map(temp => temp.label).join(',') || item.values[0]
        }
        return {
          key: item.key,
          seqno: item.sortOrder,
          attributeValueZh: attributeValueZh,
          attributeValueEn: attributeValueEn,
          categoryCode: item.categoryCode
        }
      })
      return formData
    }
  }
}
</script>
